import { render, staticRenderFns } from "./MetalAvgPrcCount.vue?vue&type=template&id=0b453711&scoped=true&"
import script from "./MetalAvgPrcCount.vue?vue&type=script&lang=js&"
export * from "./MetalAvgPrcCount.vue?vue&type=script&lang=js&"
import style0 from "./MetalAvgPrcCount.vue?vue&type=style&index=0&id=0b453711&scoped=true&lang=css&"
import style1 from "./MetalAvgPrcCount.vue?vue&type=style&index=1&lang=css&"
import style2 from "./MetalAvgPrcCount.vue?vue&type=style&index=2&id=0b453711&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b453711",
  null
  
)

export default component.exports